import React, { useEffect, useRef } from 'react';
import Float from './Float';
import Label from './Label';
import Button from './Button';
import ModalButton from './ModalButton';
import Card from './Card';
import ConsoleHeader from '../components/ConsoleHeader';

const Screen = (props) => {

    const { controller = "", signal = {}, closable = false, title = "", callback = () => { }, is_modal = false, component, offset = [0, 0], pin = true } = props;

    // const modalRef = useRef(null);




    return (
        <div className='ui-screen'>
            <div style={{ width: 'clamp(1180px, 100vw, 1440px)', "height": "calc(100vh - 50px)", "minHeight": "598px", "margin": "0 auto" }}>
                <ConsoleHeader controller={controller} is_modal={is_modal} signal={signal} />
                {React.cloneElement(component, { callback: callback })}
            </div>
        </div>
    );
};

export default Screen;
